import styled, { css } from 'styled-components'
import { ListHeader } from '../List'
import React, { useEffect } from 'react'

const StyledListHeader = styled(ListHeader).attrs({ as: 'th' })<{
  $cursor?: boolean
}>(
  ({ $cursor }) => css`
    /* override so Lists are still capitalized */
    text-transform: none !important; /* stylelint-disable-line declaration-no-important */
    /* 16px (8px + 8px) because TableHeader don't show margin */
    padding: 8px 12px 16px;
    cursor: ${$cursor ? 'pointer' : 'default'};
    font-size: ${({ theme }) => theme.fontSizes.C};
  `
)

export interface TableHeaderCellProps
  extends React.ComponentProps<typeof StyledListHeader> {
  intersectionObserver?: IntersectionObserver | null
}

export const TableHeaderCell = styled(function TableHeaderCell(
  props: TableHeaderCellProps
) {
  const { children, intersectionObserver, ...otherProps } = props
  const cellRef = React.useRef<HTMLTableCellElement>(null)

  useEffect(() => {
    if (!intersectionObserver || !cellRef.current) {
      return
    }

    const cell = cellRef.current
    intersectionObserver.observe(cell)

    return () => {
      intersectionObserver.unobserve(cell)
    }
  }, [intersectionObserver])

  return (
    <StyledListHeader {...otherProps} ref={cellRef}>
      {children}
    </StyledListHeader>
  )
})``
